import React, { useMemo } from "react";
import dynamic from "next/dynamic";
const Button = dynamic(() => import("../Button"));
const Section = dynamic(() => import("@/Components/LayoutComponents/Section"));
import Link from "next/link";
import styles from "./style.module.scss";

type ActionCardProps = {
  data: any;
};

const BuildSection: React.FC< ActionCardProps> = ({ data  }) =>  {
  const titleClassName = "max-w-[1230px]";

  // Build the class name once so SSR and CSR match exactly
  const sectionClassName = useMemo(
    () => `${styles.sectionWrapper} xl:py-[100px] md:py-[95px] py-[56px]`,
    []
  );

  return (
    <Section className={sectionClassName}>
      <div className={styles.gradientOverlay}>
        <div className={styles.innerGradient} />
      </div>

      <div className="container text-center">
        <h2
          className={`mx-auto font-bold text-primary-text text-heading-1 ${titleClassName}`}
        >
          {data?.title || ""}
        </h2>

        {data?.description && (
          <p className="font-regular max-w-[914px] mx-auto text-heading-6 text-secondary-text mt-3">
            {data?.description || ""}
          </p>
        )}

        {data?.text && (
          <p className="font-regular max-w-[914px] mx-auto text-heading-6 text-secondary-text mt-3">
            {data?.text || ""}
          </p>
        )}
        {((data?.Link?.[0]?.href && data.Link?.[0]?.label) ||
          (data?.button?.href && data?.button?.label)) && (
          <Link
            href={data?.Link?.[0]?.href ?? data?.button?.href ?? ""}
            className="mx-auto"
            target="_blank"
          >
            <Button
              label={data?.Link?.[0]?.label ?? data?.button?.label ?? ""}
              className="lg:mt-10 mt-8 mx-auto"
              onClick={() => {}}
            />
          </Link>
        )}

        {data?.buttons?.[0]?.link?.href && data?.buttons?.[0]?.link?.label && (
          <Link
            href={data?.buttons?.[0]?.link?.href || ""}
            className="mx-auto"
            target="_blank"
          >
            <Button
              label={data?.buttons?.[0]?.link?.label || ""}
              className="lg:mt-10 mt-8 mx-auto"
              onClick={() => {}}
            />
          </Link>
        )}
      </div>
    </Section>
  );
};
export default BuildSection;